/**
 * Contacts API Queries
 *
 * Query keys and search operations.
 */

// API client
import { apiClient } from '../client';
import { createResourceListQueryKeys } from '../resourceListPage/queryKeys';

// Types
import type { ContactShowResponse, ContactsResponse, FetchContactsParams } from './types';

export const contactsQueryKeys = createResourceListQueryKeys<FetchContactsParams>('contacts');

export async function getContacts(params: FetchContactsParams = {}): Promise<ContactsResponse> {
  const { data } = await apiClient.get<ContactsResponse>('/api/contacts', { params });
  return data;
}

export async function getContact(id: number): Promise<ContactShowResponse> {
  const { data } = await apiClient.get<ContactShowResponse>(`/api/contacts/${id}`);
  return data;
}
